module.exports = __webpack_public_path__ + "static/activities-pic-02-4c4fae127da46672a5373b3a44e4a668.jpg";